import React from "react";
import { createMarkup, isFieldError } from "../../helpers";

const Input = ({
	type = "text",
	label,
	note = "",
	reqd,
	name,
	value,
	update,
	errors,
	autocomplete = name,
	placeholder = "",
	addonIcon = "",
	readonly = false,
	ref = null,
}) => {
	return (
		<div className={isFieldError(errors, name) ? "has-error" : ""}>
			{label && (
				<label htmlFor={name} className="control-label">
					<span dangerouslySetInnerHTML={createMarkup(label)} />{" "}
					{reqd && <span className="reqd">*</span>}
				</label>
			)}
			{addonIcon ? (
				<div className="input-group">
					<div className="input-group-addon">
						<i className="fa fa-usd"></i>
					</div>
					<input
						type={type === "password" ? "password" : "text"}
						name={type === "text-secure" ? null : name}
						id={name}
						defaultValue={value || ""}
						onChange={(e) => update(name, e.target.value)}
						autoComplete={autocomplete}
						placeholder={placeholder}
						readOnly={readonly}
						ref={ref}
						className={
							isFieldError(errors, name)
								? "form-control error-border"
								: "form-control"
						}
					/>
				</div>
			) : (
				<input
					type={type}
					name={type === "text-secure" ? null : name}
					id={name}
					defaultValue={value || ""}
					onChange={(e) => update(name, e.target.value)}
					autoComplete={autocomplete}
					placeholder={placeholder}
					readOnly={readonly}
					ref={ref}
					className={
						isFieldError(errors, name)
							? "form-control error-border"
							: "form-control"
					}
				/>
			)}
			<span className={note ? "note" : "hidden"}>{note}</span>
		</div>
	);
};

export default Input;
